import { ClipboardModule } from '@angular/cdk/clipboard';
import { registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { CUSTOM_ELEMENTS_SCHEMA, isDevMode, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ServiceWorkerModule } from '@angular/service-worker';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ScullyLibModule } from '@scullyio/ng-lib';
import player, { LottiePlayer } from 'lottie-web';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { LightboxModule } from 'ngx-lightbox';
import { LottieModule } from 'ngx-lottie';
import { MarkedOptions, MarkedRenderer, MarkdownModule } from 'ngx-markdown';
import { register as registerSwiper } from 'swiper/element/bundle';

import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AgenciesComponent } from './content/agencies/agencies.component';
import { BlogComponent } from './content/blogs/blog/blog.component';
import { BlogsComponent } from './content/blogs/blogs.component';
import { ClientComponent } from './content/client/client.component';
import { HomeJumbotronComponent } from './content/home/home-jumbotron/home-jumbotron.component';
import { HomeOfferGroupsComponent } from './content/home/home-offer-groups/home-offer-groups.component';
import { HomeSpiritComponent } from './content/home/home-spirit/home-spirit.component';
import { HomeComponent } from './content/home/home.component';
import { JobComponent } from './content/jobs/job/job.component';
import { JobsComponent } from './content/jobs/jobs.component';
import { LabsComponent } from './content/labs/labs.component';
import { OfferComponent } from './content/offers/offer/offer.component';
import { OffersComponent } from './content/offers/offers.component';
import { ShowcaseComponent } from './content/showcases/showcase/showcase.component';
import { ShowcasesComponent } from './content/showcases/showcases.component';
import { SpiritComponent } from './content/spirit/spirit.component';
import { TeamComponent } from './content/teams/team/team.component';
import { TeamsComponent } from './content/teams/teams.component';
import { CloudinaryUrlModule } from './shared/cloudinary-url/cloudinary-url.module';
import { CustomTranslateModule } from './shared/custom-translate/custom-translate.module';
import { GraphQLModule } from './shared/data/graphql.module';
import { LayoutSeoModule } from './shared/layout-seo/layout-seo.module';
import { LayoutModule } from './shared/layout/layout.module';
import { LivechatModule } from './shared/livechat/livechat.module';
import { LocationModule } from './shared/location/location.module';
import { MeetingModule } from './shared/meeting/meeting.module';
import { PipeModule } from './shared/pipe/pipe.module';
import { UiModule } from './shared/ui/ui.module';

registerSwiper();
registerLocaleData(localeFr, 'fr');

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function markedOptionsFactory(): MarkedOptions {
  const renderer = new MarkedRenderer();
  renderer.heading = (text: string, level: number): string => `<h${level + 1}>${text}</h${level + 1}>`;
  return { renderer };
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function playerFactory(): LottiePlayer {
  return player;
}

@NgModule({
  declarations: [
    AppComponent,
    BlogsComponent,
    BlogComponent,
    ClientComponent,
    HomeComponent,
    HomeJumbotronComponent,
    HomeOfferGroupsComponent,
    HomeSpiritComponent,
    JobsComponent,
    JobComponent,
    LabsComponent,
    OffersComponent,
    OfferComponent,
    SpiritComponent,
    TeamsComponent,
    TeamComponent,
    AgenciesComponent,
    ShowcasesComponent,
    ShowcaseComponent,
  ],
  imports: [
    BrowserModule,
    MarkdownModule.forRoot({
      markedOptions: {
        provide: MarkedOptions,
        useFactory: markedOptionsFactory,
      },
    }),
    LottieModule.forRoot({
      player: playerFactory,
    }),
    NgxGoogleAnalyticsModule.forRoot(environment.ga),
    NgxGoogleAnalyticsRouterModule,
    ScullyLibModule.forRoot({
      useTransferState: true,
      alwaysMonitor: true,
    }),
    CustomTranslateModule,
    HttpClientModule,
    FontAwesomeModule,
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable',
    }),
    MeetingModule,
    LocationModule,
    LayoutSeoModule,
    LayoutModule,
    LivechatModule,
    GraphQLModule,
    CloudinaryUrlModule,
    ClipboardModule,
    UiModule,
    LightboxModule,
    PipeModule,
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'fr' }],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
